import classNames from "classnames";
import { get } from "lodash";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useMutation, useQuery } from "shared/hooks/useApi";
import { NAME_SPACES } from "shared/locales/constants";
import { UPDATE_PROJECT } from "utils/api/graphql/mutations/projects";
import { PROCESS_STATUS } from "utils/api/graphql/queries/process-statuses";
import { PROJECT } from "utils/api/graphql/queries/projects";
import phoneCallbackIcon from "../../../../Assets/icons/phone_callback.svg";
import phoneMsgIcon from "../../../../Assets/icons/phone_msg.svg";
import HelpModal from "./Modal";
import HelpContactModal from "./ModalContact";
import PromptModal from "./PromptModal";
import Timer from "./Timer";
import useHelpPrompts from "./useHelpPrompts";

function Help({ project, hideDetails, stepId, timerSlot }) {
  const { t } = useTranslation(NAME_SPACES.PUBLIC.ACORIS);
  const TRANSLATION = t("NAVBAR", { returnObjects: true });
  const [open, setOpen] = useState(false);
  const [promptOpen, setPromptOpen] = useState(false);
  const [contacted, setContacted] = useState(false);
  const [updateProject] = useMutation(UPDATE_PROJECT, {
    refetchQueries: [
      {
        query: PROJECT,
        awaitRefetchQueries: true,
        variables: { where: { id: project?.id } },
      },
    ],
  });

  const { data: statusData } = useQuery(PROCESS_STATUS, {
    variables: { where: { id: stepId } },
    skip: !stepId,
  });

  const onSubmit = (data) => {
    setContacted(true);
    updateProject({
      variables: {
        where: { id: project?.id },
        data,
      },
    });
  };

  const onClose = () => {
    setOpen(false);
  };

  const onOpen = () => {
    setOpen(true);
  };

  const onPromptClose = () => {
    setPromptOpen(false);
  };

  const onPromptAccept = () => {
    setPromptOpen(false);
    setOpen(true);
  };

  const { remaining, total } = useHelpPrompts({
    stepId,
    idleDelay: get(statusData, "processStatus.config.helpPromptDelay"),
    enabled: !contacted && !project?.locked,
    busy: open || promptOpen,
    onIdle: onOpen,
    onTabLeave: () => setPromptOpen(true),
  });

  const callbackLabel = TRANSLATION?.CALLBACK || "Être rappelé";

  const MODAL = {
    [true]: (
      <HelpContactModal
        open={open}
        onSubmit={onSubmit}
        onClose={onClose}
        project={project}
      />
    ),
    [false]: (
      <HelpModal
        open={open}
        onSubmit={onSubmit}
        onClose={onClose}
        project={project}
      />
    ),
  };

  return (
    <>
      <button
        type="button"
        className={classNames("acoris-navbar__contact", {
          "acoris-navbar__contact--icon-only": hideDetails,
        })}
        onClick={onOpen}
      >
        <img
          src={phoneMsgIcon}
          alt=""
          className="acoris-navbar__contact-icon"
        />
        {!hideDetails && (
          <span className="acoris-navbar__contact-label">
            {TRANSLATION?.CONTACT_US || "Nous contacter"}
          </span>
        )}
      </button>

      <button
        type="button"
        className="acoris-help-button"
        onClick={onOpen}
        aria-label={callbackLabel}
      >
        <img
          src={phoneCallbackIcon}
          alt=""
          className="acoris-help-button__icon"
        />
        <span className="acoris-help-button__text">{callbackLabel}</span>
      </button>
      {MODAL[!!get(project, "contact.user.firstname")]}
      <Timer remaining={remaining} total={total} container={timerSlot} />
      <PromptModal
        open={promptOpen}
        onAccept={onPromptAccept}
        onClose={onPromptClose}
      />
    </>
  );
}

export default Help;
